"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
const EmptyStateBlocks = (_a) => {
  var _b = _a, { className } = _b, rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({ className: classNames("empty-state-blocks", className), width: "100", height: "72", viewBox: "0 0 110 72" }, rest), /* @__PURE__ */ React.createElement("path", { className: "empty-state-blocks__red", d: "M74 18h18a18 18 0 01-18 18z" }), /* @__PURE__ */ React.createElement("circle", { className: "empty-state-blocks__purple", cx: "64.96", cy: "45", r: "9" }), /* @__PURE__ */ React.createElement("path", { className: "empty-state-blocks__grey", d: "M6.64 49.5h8.86a42.86 42.86 0 019-21v-9.35" }), /* @__PURE__ */ React.createElement("path", { className: "empty-state-blocks__blue", d: "M56 54V18a36 36 0 00-36 36z" }), /* @__PURE__ */ React.createElement("path", { className: "empty-state-blocks__gold", d: "M73.96 36h18v18h-18z" }));
};
export default EmptyStateBlocks;
